import socketsSlice from '../reducers/sockets.reducers';

export interface ISocketsState {
  status: 'OPEN' | 'CONNECTING' | 'CLOSED' | 'CLOSING'
}

export const socketsActions = socketsSlice.actions;
